






















import Vue from 'vue';

export default Vue.extend({
  name: 'Error_404',
  methods: {
    toTop() {
      window.location.replace('https://remolabo.net/service/top/');
    },
  },
});
